import { jsx as _jsx } from "react/jsx-runtime";
import { Select } from '@robinpowered/ui-kit';
import { useTranslation } from 'react-i18next';
import { useLocationDetailByIdQuery } from '../../../generated/graphql';
import { useEffect, useMemo, useRef } from 'react';
export var LevelSelect = function (_a) {
    var locationId = _a.locationId, value = _a.value, onChange = _a.onChange, selectedLevelId = _a.selectedLevelId;
    var t = useTranslation('spaceBooking').t;
    var selectRef = useRef(null);
    var isFirstRender = useRef(true);
    var _b = useLocationDetailByIdQuery({
        variables: { locationId: locationId !== null && locationId !== void 0 ? locationId : '' },
        skip: !locationId,
    }), data = _b.data, loading = _b.loading;
    var options = useMemo(function () {
        var _a, _b;
        if (!data)
            return;
        return (_b = (_a = data === null || data === void 0 ? void 0 : data.getLocationById) === null || _a === void 0 ? void 0 : _a.levels) === null || _b === void 0 ? void 0 : _b.filter(function (level) { return (level === null || level === void 0 ? void 0 : level.totalSpaces) > 0; }).map(function (level) { return ({
            label: level.name,
            value: level.id,
        }); });
    }, [data]);
    /* If no level is selected, select the first level */
    useEffect(function () {
        var _a;
        if (!selectedLevelId && ((_a = options === null || options === void 0 ? void 0 : options[0]) === null || _a === void 0 ? void 0 : _a.value)) {
            onChange(options[0].value);
        }
    }, [selectedLevelId, options, onChange]);
    /* Focus the floor dropdown when location changes (skip initial mount) */
    useEffect(function () {
        var _a;
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        if (locationId) {
            (_a = selectRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [locationId]);
    return (_jsx(Select, { ref: selectRef, loading: loading, value: value, options: options, filterOption: function (input, option) { var _a; return ((_a = option === null || option === void 0 ? void 0 : option.label) !== null && _a !== void 0 ? _a : '').toLowerCase().includes(input.toLowerCase()); }, onChange: onChange, placeholder: t('level_select.placeholder'), style: { width: '100%' }, showSearch: true }));
};
